import { Component } from '@angular/core';
import { AlertController, IonicPage, ModalController, NavController, Platform, NavParams } from 'ionic-angular';
import moment from 'moment';
import { ApiProvider } from '../../providers/api/api';
// import { SearchPage } from '../search/search';
// import { TabsPage } from '../tabs/tabs';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { FileOpener } from '@ionic-native/file-opener';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { File } from '@ionic-native/file';
import { ApplePay } from '@ionic-native/apple-pay/ngx';
// import { InAppPurchase } from '@ionic-native/in-app-purchase/ngx';

// import { IAPProduct, InAppPurchase2 } from '@awesome-cordova-plugins/in-app-purchase-2/ngx';

declare var window: any;


/**
 * Generated class for the AgentsubscriptionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-agentsubscription',
  templateUrl: 'agentsubscription.html',
})
export class AgentsubscriptionPage {


  monthly_key = "hscodes.com.hscode.monthly";
  quaterly_key = "hscodes.com.hscode.quarterly";
  yearly_key = "hscodes.com.hscode.yearly";

  monthly_count = 0;
  quaterly_count = 0;
  yearly_count = 0;
  products: any = [];
  previouspurchases: any = [];
  // Expirydate= moment().add(15, 'd').format();
  editdata: any = [];
  offerduration: any = [];
  SubscriptionData: any[] = []; submitData: any = {}; amount: any; pet: string; yamount: any; qamount: any; membership_id: any; to_amt_silver: any; to_amt_gold: any; to_amt_platinum: any;
  m_silver: any; m_gold: any; m_platinum: any; usd_q_silver: any; usd_q_gold: any; usd_q_platinum: any;
  q_silver: any; q_gold: any; q_platinum: any; currencydata: any; usd_silver: any; usd_gold: any; usd_platinum: any; usd_m_silver: any; usd_m_gold: any; allCountrys: any[] = [];
  currencyData: any[] = []; usd_m_platinum: any; usr_credit: any; pdfObj = null; converted: any; convertedAmount: any; currencyFrom; currencyTo;
  selecteduserdata: any;
  payment_mode: boolean;

  toDisplayMonthly: any = "";
  toDisplayQuarterly: any = "";
  toDisplayYearly: any = "";
  constructor(private plt: Platform, private fileOpener: FileOpener, private file: File, public navCtrl: NavController, public navParams: NavParams, private apiProvider: ApiProvider,
    private modalCtrl: ModalController, private alertCtrl: AlertController,
    public platform: Platform,
    //public iap2: InAppPurchase2,
    public applepay: ApplePay) {
    this.selecteduserdata = JSON.parse(this.navParams.get('k_EAIaIQobChMI_grid_4S7oZb45gIVzsreCh2kRAucEAAYASAAEgIFcfD_BwE_k_&ext_vrnchi&gclidEAIaIQobChMI_4S7oZb45gIVzsreCh2kRAucEAAYASAAEgIFcfD_BwE'));
    console.log(this.selecteduserdata);
    localStorage.setItem('subscription_user_Data', JSON.stringify(this.selecteduserdata));

    this.getallCountrysData();
    this.subscriptionDetails();

    this.pet = 'free';
  }

  enableItems(id) {
    if (id === this.monthly_key) {
      this.monthly_count += 100;
    }
    else if (id === this.quaterly_key) {

    }
    // else if(id === this.yearly_key){

    // }
  }
  restore1() {
    // sultan removed it
    // this.iap2.restorePurchases().then(purchases => {
    //   this.previouspurchases = purchases;
    //   console.log(this.previouspurchases);
    //   for (let prev of this.previouspurchases) {
    //     this.enableItems(prev.productId);
    //   }
    // })
  }
  restore() {
    // Sultan removed It
    // this.iap2.buy('hscodes.com.hscode.montly').then(data => {
    //   this.enableItems('hscodes.com.hscode.montly');
    //   console.log(data);
    // }).catch(err => {
    //   console.log(err);
    // })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SubscriptionPage');
  }
  ngOnInIt() {
    this.plt.ready().then((message) => {
      console.log("apple pay" + message);
      this.applepay.canMakePayments().then(msg => {

        console.log("ashish" + msg)
      }, err => {
        console.log('pamnet avaialble');
        alert('' + err)
      })
    }, err => {
      console.log()
    })
  }
  private getallCountrysData() {

    this.apiProvider.getCurrency().subscribe((res: any) => {
      console.log(res.data);
      this.currencyData = res.data
      console.log(this.currencyData);


    })

    this.apiProvider.getallCountrys().subscribe((res: any) => {
      console.log(res.data)
      this.allCountrys = res.data;
      console.log(this.allCountrys);
    }, er => {
      console.log(er);
    })
  }

  goBack() {
    this.navCtrl.pop();
  }
  gotopage(id) {
    if (id == 0) {
      this.navCtrl.setRoot('AgenthomePage');
    } else if (id == 1) {
      this.navCtrl.push('AgentrequesttrackingPage');
    } else if (id == 2) {
      this.navCtrl.push('AgentviewleadsPage');
    } else if (id == 3) {
      this.navCtrl.push('AgentuseraddPage');
    } else if (id == 4) {
      this.navCtrl.push('AgentdataPage');
    }

  }

  private getCountrysDataFrom(event) {

    var data = {
      'country': event.value.country_nm
    }
    this.apiProvider.getCountryid(data).subscribe((res: any) => {
      console.log(res.data);
      const cid = res.data[0].country_id;
      // localStorage.setItem('currency_country_id', this.geo_country_id);
      console.log(cid);

      this.currencyFrom = this.currencyData.filter(word => word.country_id == cid)[0].currency_cd;
      console.log(this.currencyFrom);


    })

  }

  private getCountrysDataTo(event) {

    var data = {
      'country': event.value.country_nm
    }
    this.apiProvider.getCountryid(data).subscribe((res: any) => {
      console.log(res.data);
      const cid = res.data[0].country_id;
      // localStorage.setItem('currency_country_id', this.geo_country_id);
      console.log(cid);

      this.currencyTo = this.currencyData.filter(word => word.country_id == cid)[0].currency_cd;
      console.log(this.currencyTo);
    })

  }

  currencyConverter() {
    // console.log(price.target.value);


    fetch(`https://api.exchangerate-api.com/v4/latest/${this.currencyFrom}`)
      .then(res => res.json())
      .then(res => {
        const usd_rate = res.rates[this.currencyTo];
        console.log(usd_rate);
        this.convertedAmount = Math.round((this.converted * usd_rate));
        console.log(this.convertedAmount);
      })
  }

  private subscriptionDetails() {

    const data = {
      // country[0].usr_country
      'country_id': this.selecteduserdata.usr_country,
      'user_id': this.selecteduserdata.usr_id
    }
    console.log(data);
    localStorage.setItem('user_country_id', data.country_id)
    this.apiProvider.getSubscriptionDetails(data).subscribe((res: any) => {
      console.log(res)
      this.editdata = [];
      // this.SubscriptionData = res.data;
      for (var i = 0; i < res.data.length; i++) {
        if (i == 13 || i == 14 || i == 15 || i == 16 || i == 17 || i == 18 || i == 19 || i == 20 || i == 21 || i == 22 || i == 23 || i == 24 || i == 25 || i == 26 || i == 27 || i == 32 || i == 34 || i == 36 || i == 40) {
          // console.log(res.data[i]);
          this.editdata.push(res.data[i])

        }
        if (i == 40) {
          console.log(res.data[i]);
          this.offerduration = res.data[i];
          localStorage.setItem('offerduration', JSON.stringify(this.offerduration));
        } else {
          console.log("hitted", i);

          this.SubscriptionData.push(res.data[i])
        }

      }
      console.log(this.SubscriptionData);
      console.log(this.SubscriptionData);
      this.currencydata = res.currency[0].currency_cd
      console.log(this.currencydata)
      const aamount = this.SubscriptionData.filter(word => word.description == 'PACKAGE - COSTING PER YEAR IN USD');
      const yamount = this.SubscriptionData.filter(word => word.description == 'PACKAGE MONTHLY PAYMENT OPTIONS IN USD');
      const qamount = this.SubscriptionData.filter(word => word.description == 'PACKAGE QUATERLY PAYMENT OPTIONS IN USD');
      const credits = this.SubscriptionData.filter(word => word.description == 'CREDITS ');
      this.amount = aamount[0];
      this.yamount = yamount[0];
      this.qamount = qamount[0];
      this.usr_credit = credits[0];
      console.log(this.usr_credit, this.amount, this.yamount, this.qamount);
      //currency converter
      const from_currency = 'USD';
      const to_currency = this.currencydata;
      fetch(`https://api.exchangerate-api.com/v4/latest/${from_currency}`)
        .then(res => res.json())
        .then(res => {
          const rate = res.rates[to_currency];
          var demo = `1 ${from_currency} = ${rate} ${to_currency}`
          console.log(demo)
          this.to_amt_silver = Math.round((this.amount.silver * rate));
          console.log(this.to_amt_silver);
          this.to_amt_gold = Math.round((this.amount.gold * rate));
          this.to_amt_platinum = Math.round((this.amount.platinum * rate));
          this.m_silver = Math.round((this.yamount.silver * rate));
          console.log(this.m_silver);
          this.m_gold = Math.round((this.yamount.gold * rate));
          this.m_platinum = Math.round((this.yamount.platinum * rate));

          this.q_silver = Math.round((this.qamount.silver * rate));
          console.log(this.q_silver);
          this.q_gold = Math.round((this.qamount.gold * rate));
          this.q_platinum = Math.round((this.qamount.platinum * rate));
          //for usd start
          const usd_rate = res.rates['USD'];
          this.usd_silver = Math.round((this.amount.silver * usd_rate));
          this.usd_gold = Math.round((this.amount.gold * usd_rate));
          this.usd_platinum = Math.round((this.amount.platinum * usd_rate));
          if (localStorage.getItem('user_country_id') == "101") {
            this.m_silver = this.m_silver + Math.round(this.m_silver * 0.18);
            this.q_silver = this.q_silver + Math.round(this.q_silver * 0.18);
            this.to_amt_silver = this.to_amt_silver + Math.round(this.to_amt_silver * 0.18);
            this.amount.silver = this.amount.silver + Math.round(this.amount.silver * 0.18);
          }

          if (localStorage.getItem('user_country_id') == "101") {
            this.toDisplayMonthly = to_currency + ' ' + this.m_silver;
            this.toDisplayQuarterly = to_currency + ' ' + this.q_silver;
            this.toDisplayYearly = to_currency + ' ' + this.to_amt_silver;
          } else {
            this.toDisplayMonthly = from_currency + '($) ' + this.yamount.silver;
            this.toDisplayQuarterly = from_currency + '($) ' + this.qamount.silver;
            this.toDisplayYearly = from_currency + '($) ' + this.amount.silver;
          }
          if (localStorage.getItem('user_country_id') == "101") {
            console.log(localStorage.getItem('user_data'));
            var abc = localStorage.getItem('user_data');
            //this.to_amt_silver = 2950.00;
            console.log('india')
            this.usd_m_silver = Math.round((this.yamount.silver * usd_rate));
            this.payment_mode = true;
          } else {
            console.log('other country...')
            this.usd_m_silver = Math.round((this.yamount.silver * usd_rate));
            this.payment_mode = true;
          }
          this.usd_m_gold = Math.round((this.yamount.gold * usd_rate));
          this.usd_m_platinum = Math.round((this.yamount.platinum * usd_rate));
          this.usd_q_silver = Math.round((this.qamount.silver * usd_rate));
          this.usd_q_gold = Math.round((this.qamount.gold * usd_rate));
          this.usd_q_platinum = Math.round((this.qamount.platinum * usd_rate));
          //End
        })
      // end
    }, er => {
      console.log(er);
    })
  }

  payAmount(name) {
    console.log(name);

    this.submitData.type = name;
    if (name == 'silver') {
      this.submitData.year = this.to_amt_silver;
      this.submitData.month = this.m_silver;
      this.submitData.quaterly = this.q_silver;
      this.submitData.currency_cd = this.currencydata;
      this.submitData.credits = this.usr_credit.silver;
      this.submitData.usd_year = this.usd_silver;
      this.submitData.usd_month = this.usd_m_silver;
      this.submitData.usd_quaterly = this.usd_q_silver;
      this.submitData.id = 3;
      this.submitData.limit = 1;
      this.submitData.editdata = this.editdata;

      const m = this.modalCtrl.create(agentpaymentModal, { title: this.submitData });
      m.present();
      m.onDidDismiss((res) => {
        var logt = "";
        logt = localStorage.getItem("logoutsub");
        if (logt == "logoutsub") {
          localStorage.clear();
          this.navCtrl.setRoot('SignupPage', { "sigmentstatus": "login" });
        }

      });
    }
    // if (name == 'gold') {
    //   this.submitData.year = this.to_amt_gold;
    //   this.submitData.month = this.m_gold;
    //   this.submitData.quaterly = this.q_gold;
    //   this.submitData.currency_cd = this.currencydata;
    //   this.submitData.credits = this.usr_credit.gold;
    //   this.submitData.usd_year = this.usd_gold;
    //   this.submitData.usd_month = this.usd_m_gold;
    //   this.submitData.usd_quaterly = this.usd_q_gold;
    //   this.submitData.id = 2;
    //   this.submitData.limit = 3;
    // }
    // if (name == 'platinum') {
    //   this.submitData.year = this.to_amt_platinum;
    //   this.submitData.month = this.m_platinum;
    //   this.submitData.quaterly = this.q_platinum;
    //   this.submitData.currency_cd = this.currencydata;
    //   this.submitData.credits = this.usr_credit.platinum;
    //   this.submitData.usd_year = this.usd_platinum;
    //   this.submitData.usd_month = this.usd_m_platinum;
    //   this.submitData.usd_quaterly = this.usd_q_platinum;
    //   this.submitData.id = 1;
    //   this.submitData.limit = 7;
    // }
    // console.log(this.submitData)
    // let modal = this.modalCtrl.create(agentpaymentModal, { title: this.submitData });
    // modal.present();
    // const m = this.modalCtrl.create('AgentsubscriptionpaymentPage', { title: this.submitData });
    // m.present();
    // m.onDidDismiss((res) => {

    // })

  }

  gotoSearchPage() {
    this.navCtrl.push('SearchPage');
  }

  LogOut() {
    this.logOutAlert();
  }
  selectOnePayment() {
    const alert = this.alertCtrl.create({
      cssClass: 'my-custom-class',
      // title: 'ugyugcu',
      subTitle: 'Currently We have only one Inaugural offer package running. This package will be available in the near future.',
      mode: 'ios',
      buttons: [
        {
          text: 'ok',
          handler: () => {
            this.pet = 'silver';
          }
        },
      ]

    });
    alert.present();
  }
  logOutAlert() {
    const alert = this.alertCtrl.create({
      cssClass: 'my-custom-class',
      subTitle: 'Are you sure you want to Logout?',
      buttons: [{
        text: 'No',
        handler: () => {
        }
      }, {
        text: 'Ok',
        handler: () => {
          localStorage.clear();
          window.location.reload();
        }
      },
      ]
    });
    alert.present();
  }
  createPdf(one, year) {
    var rows = [];
    console.log(this.SubscriptionData);

    for (var p = 0; p < this.SubscriptionData.length; p++) {
      rows.push([this.SubscriptionData[p].description, this.SubscriptionData[p].free, this.SubscriptionData[p].silver, this.SubscriptionData[p].gold, this.SubscriptionData[p].platinum]);
    }

    // let img = 'https://live.staticflickr.com/2912/13981352255_fc59cfdba2_b.jpg';
    var docDefinition = {
      content: [{
        table: {
          headerRows: 1,
          widths: [94.4, 94.4, 94.4, 94.4, 94.4],
          body: [
            [{ text: 'Description', bold: true }, { text: 'Free', bold: true }, { text: 'Silver', bold: true }, { text: 'Gold', bold: true }, { text: 'Platinum', bold: true }],
            // ['Value 1', 'Value 2', 'Value 3', 'Value 4'],
            // [{ text: 'Bold value', bold: true }, 'Val 2', 'Val 3', 'Чё']
          ]
        }
      }, {
        table: {
          widths: [94.4, 94.4, 94.4, 94.4, 94.4],
          body: rows,
        }
      },


      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10],
          alignment: 'center'
        },
        header2: {
          fontSize: 25,
          bold: true,
          alignment: 'center'
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 20, 0, 5]
        },
        itemsTable: {
          // margin: [0, 5, 0, 15]
        },
        itemsTableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black'
        },
        itemsTables: {
          margin: [0, 5, 0, 15]
        },
        itemsTableHeaders: {
          bold: true,
          fontSize: 13,
          color: 'black'
        },
        totalsTable: {
          bold: true,
          margin: [0, 30, 0, 0]
        }
      },



    }


    this.pdfObj = pdfMake.createPdf(docDefinition);
    this.downloadPdf();
  }





  downloadPdf() {
    if (this.plt.is('cordova')) {
      this.pdfObj.getBuffer((buffer) => {
        var blob = new Blob([buffer], { type: 'application/pdf' });

        // Save the PDF to the data Directory of our App
        this.file.writeFile(this.file.dataDirectory, 'downloadfile.pdf', blob, { replace: true }).then(fileEntry => {
          // Open the PDf with the correct OS tools
          this.fileOpener.open(this.file.dataDirectory + 'downloadfile.pdf', 'application/pdf');
        })
      });
    } else {
      // On a browser simply use download!
      this.pdfObj.download();
    }
  }


}


// PAYMENT PAGE START
declare var RazorpayCheckout: any;
@Component({
  selector: 'page-pay',
  templateUrl: 'payment.html',
})

export class agentpaymentModal {


  selectedIng: Array<any> = [];
  numberOfChecks: number = 0;
  checkBoxLimit: any;

  ProductData: any[] = [];
  submitData: any = {};
  payData: any = {};
  dateNow: Date = new Date();
  Expirydate: any;
  use: boolean = false;
  selectOptions: any;
  chapters: any = [];
  remining: any = [];
  selected: string;
  offerduration: any;
  pizzaIng: { name: string; checked: boolean; }[];
  subscription_user_data: any;
  isCopoun: boolean = false;
  isCpnEnable: boolean = false;
  copounCode = "";
  rdmonthstatus: boolean = false
  rdquaterlystatus: boolean = false
  rdYearlystatus: boolean = false
  constructor(public navCtrl: NavController, public navParams: NavParams, private apiProvider: ApiProvider, private navParam: NavParams, private alertCtrl: AlertController) {
    this.submitData = this.navParam.get('title');
    this.offerduration = JSON.parse(localStorage.getItem('offerduration'));
    this.subscription_user_data = JSON.parse(localStorage.getItem('subscription_user_Data'));
    console.log(this.offerduration);

    console.log(this.submitData);
    this.checkBoxLimit = this.submitData.limit
    this.getchapterdtls();
    this.calculate();
    this.selectOptions = {
      // subTitle: 'Select Chapter',
      mode: 'ios'
    };
    this.pizzaIng = [
      { name: "Pepperoni", checked: false },
      { name: "Sasuage", checked: false },
      { name: "Mushrooms", checked: false }
    ];
    this.selectedIng = [];
  }


  updateIng(ing) {
    console.log(ing);

    if (ing.checked === true) {
      this.selectedIng.push(ing);
      this.numberOfChecks++;
      if (this.numberOfChecks == this.checkBoxLimit) {
        alert(`You have Selected Your Maximum limit of ${this.checkBoxLimit} ${this.checkBoxLimit == '1' ? 'Chapter' : 'Chapters'}`);
      }
    } else {
      this.selectedIng = this.pizzaIng.filter((ingr) => {
        console.log(ingr['checked'])
        return ingr['checked'] === true;
      })
      this.numberOfChecks--;
    }

    console.log(this.selectedIng);
    console.log(this.numberOfChecks);
  }

  showAlert() {
    const alert = this.alertCtrl.create({
      cssClass: 'my-custom-class',
      title: 'Purchase',
      subTitle: 'You are eligible to select any one chapters from 01 - 99 , and please note once you select the chapter and make the Payment you cannot change the selected Chapter.',
      mode: 'ios',
      buttons: [{
        text: 'Ok'
      },
      ]
    });
    alert.present();
  }

  showCodeAlert(calType) {
    const alert = this.alertCtrl.create({
      cssClass: 'my-custom-class',
      title: calType + ' Coupon Success',
      subTitle: 'You are eligible to select any one chapters from 01 - 99 , and please note once you select the chapter and make the Payment you cannot change the selected Chapter.',
      mode: 'ios',
      buttons: [{
        text: 'Ok'
      },
      ]
    });
    alert.present();
  }

  showwrongCodeAlert() {
    const alert = this.alertCtrl.create({
      cssClass: 'my-custom-class',
      title: ' Wrong Coupon',
      subTitle: 'Coupon entered is not valid / expired',
      mode: 'ios',
      buttons: [{
        text: 'Ok',
        handler: () => {
          // localStorage.setItem('logoutsub', 'logoutsub');
          // this.navCtrl.setRoot('SubscriptionPage');

          // this.navCtrl.setRoot('HomePage');
          // localStorage.clear();
          // // window.location.reload();
          // this.navCtrl.setRoot('SignupPage', { "sigmentstatus": "login" });
          // this.navCtrl.push('SignupPage', { "sigmentstatus": "login" });

        }
      },
      ]
    });
    alert.present();
  }
  usecode(name) {
    if (this.isCopoun) {
      this.showCodeAlert(name);

    } else {
      this.showAlert();
    }
    if (name == 'month') {
      this.payData.ammount = this.submitData.month;
      this.payData.usd_ammount = this.submitData.usd_month;
      console.log(this.payData.ammount)
      this.Expirydate = moment().add(this.offerduration.silver * 1, 'd').format();
    }
    if (name == 'quaterly') {
      this.payData.ammount = this.submitData.quaterly;
      this.payData.usd_ammount = this.submitData.usd_quaterly;
      console.log(this.payData.ammount)
      this.Expirydate = moment().add(this.offerduration.gold * 1, 'd').format();
    }


    if (name == 'year') {
      this.payData.ammount = this.submitData.year;
      this.payData.usd_ammount = this.submitData.usd_year;
      this.Expirydate = moment().add(this.offerduration.platinum * 1, 'd').format();
    }
    console.log(this.Expirydate);
    this.use = true;
  }

  usecopoun() {
    console.log(this.isCopoun);
  }

  usecopouncode() {
    debugger
    var data = {
      'cpn_code': this.copounCode
    }
    this.apiProvider.validatecpncode(data).subscribe((res: any) => {
      console.log(res.data);
      if (res.data.length > 0) {
        this.isCpnEnable = true;

        if (res.data[0].cpn_days_type == "Yearly") {
          this.rdYearlystatus = true;
          this.usecode('year')
        } else if (res.data[0].cpn_days_type == "Quaterly") {
          this.usecode('quaterly')
          this.rdquaterlystatus = true;
        } else {
          this.rdmonthstatus = true;
          this.usecode('month')
        }
        // this.updatedetails(this.copounCode);

      } else {
        this.showwrongCodeAlert();
        //this.navCtrl.setRoot('SignupPage', { "sigmentstatus": "login" });
      }
      //this.loading.dismiss();
      // this.showloader = false;
      // localStorage.setItem(
      //   "main_usr_data",
      //   JSON.stringify(res.data[0])
      // );
      // console.log(this.usrdata);
    }, er => {
      this.showwrongCodeAlert();
      // localStorage.clear();
      // window.location.reload();
      // this.navCtrl.setRoot('SignupPage', { "sigmentstatus": "login" });
    })
  }

  getchapterdtls() {
    // this.showloader = true;
    var cont = {
      'section_id': 0
    }
    this.apiProvider.getchaptersdata(cont).subscribe((res: any) => {
      // this.showloader = false;
      this.chapters = res.data;
      this.chapters.map(i => { i["checked"] = false });
      console.log(this.chapters);
    }, er => {
      // this.showloader = false;
      console.log(er);
    })
  }
  currency_data: any;
  amount_data;

  paymentSubmit(chapterselection) {

    // Commented by Sultan
    // this.store.order('hscodes.com.hscode.montly');
    // return;
    console.log(this.payData.ammount + "::::::" + this.payData.usd_ammount);
    // alert('payment clcik')
    // var char_arry=
    const check = this.chapters.filter(word => word.checked == true)
    const userdata = JSON.parse(localStorage.getItem('subscription_user_Data'));
    console.log(userdata);

    if (check.length == this.checkBoxLimit) {
      if (localStorage.getItem('user_country_id') == "101") {
        this.currency_data = 'INR';
        this.amount_data = Math.round(this.payData.ammount * 100);
      } else {
        this.currency_data = 'USD';
        this.amount_data = Math.round(this.payData.usd_ammount * 100);
      }
      if (this.isCopoun) {
        this.updatedetails(this.copounCode);
      } else {

        var options = {

          description: 'Membership Subscription',
          image: 'assets/imgs/logo_splash_txt.png',
          currency: this.currency_data,
          key: 'rzp_live_ZpdaTV1gAWc5f7',
          amount: this.amount_data,
          name: 'HSCODES.WORLD',
          prefill: {
            email: userdata.usr_email,
            contact: userdata.usr_ph,
            name: userdata.usr_nm,
          },
          theme: {
            color: '#0065b2'
          },
          modal: {
            ondismiss: function () {
              // alert('dismissed')
              const alert = this.alertCtrl.create({
                cssClass: 'my-custom-class',
                title: 'Dismissed',
                mode: 'ios',
                // subTitle: 'Payment Success',
                buttons: [{
                  text: 'Ok',
                },
                ]
              });
              alert.present();
            }
          }
        };

        var successCallback = (payment_id) => {
          this.updatedetails(payment_id);
          const alert = this.alertCtrl.create({
            cssClass: 'my-custom-class',
            title: payment_id,
            mode: 'ios',
            subTitle: 'Payment Success',
            buttons: [{
              text: 'Ok',
            },
            ]
          });
          alert.present();
          // alert('payment_id: ' + payment_id);
          // alert('Payment Successful! ');
          //Navigate to another page using the nav controller
          //this.navCtrl.setRoot(SuccessPage)
          //Inject the necessary controller to the constructor

        };
        var cancelCallback = (error) => {
          console.log(error);

          // alert(error.description + ' (Error ' + error.code + ')'); 
          const alert = this.alertCtrl.create({
            cssClass: 'my-custom-class',
            title: error.description,
            mode: 'ios',
            subTitle: 'Payment failed',
            buttons: [{
              text: 'Ok',
            },
            ]
          });
          alert.present();

          //Navigate to another page using the nav controller
          //this.navCtrl.setRoot(ErrorPage)
        };
        RazorpayCheckout.open(options, successCallback, cancelCallback);
      }

    } else {
      const alert = this.alertCtrl.create({
        cssClass: 'my-custom-class',
        title: `You Can Select Upto ${this.checkBoxLimit} ${this.checkBoxLimit == '1' ? 'Chapter' : 'Chapters'}` + ' for ' + `${this.submitData.id == '1' ? 'Platinum' : this.submitData.id == '2' ? 'Gold' : this.submitData.id == '3' ? 'Silver' : ''}` + ' subscription',
        subTitle: 'Please Select',
        mode: 'ios',
        buttons: [{
          text: 'Ok',
        },
        ]
      });
      alert.present();
      // alert(`You Can Select Upto ${this.checkBoxLimit} ${this.checkBoxLimit == '1' ? 'Chapter': 'Chapters'}` + ' for ' + `${this.submitData.id == '1' ? 'Platinum' : this.submitData.id == '2' ? 'Gold' : this.submitData.id == '3' ? 'Silver' : ''}` + ' subscription');     
    }

  }

  updatedetails(payment_id) {
    console.log(moment(new Date()).format("DD/MM/YYYY"));
    const country = JSON.parse(localStorage.getItem('subscription_user_Data'));
    this.payData.usr_id = this.subscription_user_data.usr_id;
    this.payData.start_dt = moment(new Date()).format("YYYY-MM-DD");
    this.payData.expiry_dt = moment(this.Expirydate).format("YYYY-MM-DD");
    this.payData.membership_type = this.submitData.type;
    this.payData.membership_id = this.submitData.id;
    this.payData.usr_credits = this.submitData.credits;
    this.payData.payment_id = payment_id;
    this.payData.chapterselectionArray = this.chapters.filter(word => word.checked == true);;
    console.log(this.payData, this.chapters);
    this.payData.selectedrestrictionarray = this.submitData.editdata;
    if (this.isCopoun) {
      this.payData.iscoupon = "1";
    }
    debugger
    this.apiProvider.paymentSubmit(this.payData).subscribe((res: any) => {

      if (this.isCopoun) {
        var data = {
          'cpn_code': this.copounCode,
          'cpn_usedby': this.subscription_user_data.usr_id,
        }
        this.apiProvider.updatecpncode(data).subscribe((res: any) => {
          console.log(res.data)
        });
      }
      const alert = this.alertCtrl.create({
        cssClass: 'my-custom-class',
        title: 'Congratulation! your are successfully Upgraded?',
        subTitle: 'Please login!!!',
        mode: 'ios',
        buttons: [{
          text: 'Ok',
          handler: () => {
            localStorage.setItem('logoutsub', 'logoutsub');
            this.navCtrl.pop();
            // localStorage.clear();
            // this.navCtrl.push('SignupPage', { "sigmentstatus": "login" });

          }
        },
        ]
      });
      alert.present();
      console.log(res);
      // localStorage.clear();
      // window.location.reload()
      this.use = false;
    }, er => {
      const alert = this.alertCtrl.create({
        cssClass: 'my-custom-class',
        title: JSON.stringify(er),
        mode: 'ios',
        subTitle: 'Error Found',
        buttons: [{
          text: 'Ok',
        },
        ]
      });
      alert.present();
    })
  }

  closeModal() {
    this.navCtrl.pop();
  }
  selectioncontrol(data) {
    console.log(data);
    console.log(data.length);
    console.log(this.submitData.id);
    if (this.submitData.id == 1) {
      console.log(data.length);
      if (data.length == 1) {
      } else {
        alert('You have to select only one chapter');
        this.selected = '';
      }
    } else if (this.submitData.id == 2) {
      if (data.length < 4) {

      } else {
        alert('You have to select only three chapters');
        this.selected = '';
      }
    } else if (this.submitData.id == 3) {
      if (data.length < 8) {

      } else {
        alert('You have to select only seven chapters');
        this.selected = '';
      }
    }
  }


  calculate() {
    const from_currency = 'USD';
    const to_currency = 'INR';
    fetch(`https://api.exchangerate-api.com/v4/latest/${from_currency}`)
      .then(res => res.json())
      .then(res => {
        console.log(res);
        const rate = res.rates[to_currency];
        console.log(rate);
        var demo = `1 ${from_currency} = ${rate} ${to_currency}`
        console.log(demo);
        var to_amt = (2 * rate).toFixed(2);
        console.log(to_amt)
      })
  }




}





// WEBPACK FOOTER //
// ./src/pages/agentsubscription/agentsubscription.ts